import { ref, watchEffect  } from 'vue'

const component = ref();
const show = ref(false);

export function useModal() {

    watchEffect(() => {
        document.body.classList.toggle('noscroll', show.value);
    });

    return {
        component,
        show,
        // methods to show/hide modal
        showModal: () => show.value = true,
        hideModal: () => show.value = false,
    }
}